import React from "react";

class SearchCategory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: "activity",
      open: false
    };
  }

  componentDidMount() {
    window.addEventListener("mousedown", this.detectClickOutSide);
  }
  componentWillUnmount() {
    window.removeEventListener("mousedown", this.detectClickOutSide);
  }

  detectClickOutSide = e => {
    if (!this.searchType.contains(e.target)) {
      this.setState({ open: false });
    }
  };

  handleSelect = category => {
    this.setState({ selected: category, open: false });
    this.props.selectedCategory(category);
  };
  render() {
    return (
      <div className="desktop__search_category__container" ref={node => (this.searchType = node)}>
        <div
          className="desktop__search_category__selected"
          onClick={() => this.setState(prev => ({ open: !prev.open }))}
        >
          <div className="desktop__search_category_icon" />
          <div className="search__selected_category">{this.state.selected}</div>
          <div className={`dropdown__icon ${this.state.open ? "open" : ""}`} />
        </div>
        {this.state.open && (
          <ul className="dropdown__list">
            <li className="item" onClick={() => this.handleSelect("activity")}>
              Activity
            </li>
            <li className="item" onClick={() => this.handleSelect("places")}>
              Places
            </li>
          </ul>
        )}
      </div>
    );
  }
}

export default SearchCategory;
